import React from "react";

const ProgressBar = ({
  progress = 0,
  maxProgress = 100,
}: {
  progress: number;
  maxProgress: number;
}) => {
  return (
    <div className="relative w-full h-1 bg-white rounded-full overflow-hidden">
      <div
        className="absolute inset-y-0 left-0 bg-green-900 rounded-full transition-[width] duration-500"
        style={{ width: `${(progress / maxProgress) * 100}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
